import styled from 'styled-components'
import { zIndex } from 'styled-system'

const Layer = styled.div`
  position: relative;
  ${zIndex}
`

Layer.defaultProps = {
  zIndex: 0,
}

export default Layer
